<script>
  import conciliacaoProjetoServico from '../servico';
  import moment from 'moment';
  import DatePicker from 'vue2-datepicker';

  import $ from 'jquery';
  import 'select2';
  import 'select2/dist/js/i18n/pt-BR';

  import PosicaoTesourariaDetalhe from './PosicaoTesourariaDetalhe.vue';
  import PosicaoTesourariaCompromissos from './PosicaoTesourariaCompromissos.vue';
  import AplicacoesContaModal from './AplicacoesContaModal.vue';
  import ConfiguracaoCreditoModal from './ConfiguracaoCreditoModal.vue';
  import permissoesConciliacao from '~js/permissoes-conciliacao';
  import desktopEmbed from '~js/desktop-embed';

  const CHAVE_FILTROS = 'posicao-tesouraria-filtros';

  export default {
    components: { DatePicker, PosicaoTesourariaDetalhe, PosicaoTesourariaCompromissos, AplicacoesContaModal, ConfiguracaoCreditoModal },
    data() {
      return {
        temDesktop: desktopEmbed.disponivel(),
        carregando: true,
        exportando: false,
        painel: this.painelVazio(),
        filtros: this.carregarFiltros(),
        dataReferencia: null,
        horizonte: 0,
        ateData: null,
        maisFiltros: false,
        timerFiltro: null,
        listaContas: [],
        listaProjetos: [],
        contaDetalhe: '',
        ordemAntesDivergentes: null,
        compromissosConta: null,
        aplicacoesConta: null,
        compromissosCategoria: '',
        mostrarConfiguracao: false,
        ontem: moment().subtract(1, 'day').endOf('day').toDate(),
      };
    },
    computed: {
      podeTratar() { return permissoesConciliacao.alterar('tesouraria'); },
      podeConfigurar() { return permissoesConciliacao.configurar('banco'); },
      podeConciliarBanco() { return permissoesConciliacao.consultar('banco'); },
      resumo() { return this.painel.resumo || {}; },
      totais() { return this.painel.totais || {}; },
      registros() { return this.painel.registros || []; },
      temFiltro() {
        const f = this.filtros;
        return !!f.card || !!f.idConta || !!f.banco || f.tipoConta !== '-1' || f.situacaoConta !== '0' || !!f.idProjeto
          || !!f.faixaLivre || !!f.faixaDiferenca || f.soComAplicacao || f.soComCompromisso || !!f.ordem;
      },
      contasDoBanco() {
        const banco = this.filtros.banco;
        return banco ? this.listaContas.filter(c => c.banco === banco) : this.listaContas;
      },
      colunasCompromisso() {
        return [
          { categoria: 'atrasado', titulo: 'atrasados', cls: 'lnk-atrasado', valor: r => r.atrasados, qtde: r => r.qtdeAtrasados },
          { categoria: 'apagar', titulo: 'a pagar até ' + this.painel.limite, cls: '', valor: r => r.previstos + r.vencendoSemPrevisao, qtde: r => r.qtdeAPagar },
          { categoria: 'bordero', titulo: 'em borderô', cls: '', valor: r => r.emBordero, qtde: r => r.qtdeEmBordero },
          { categoria: 'transferencia', titulo: 'transferências', cls: '', valor: r => r.transferencias, qtde: r => r.qtdeTransferencias },
        ];
      },
      temMaisFiltros() {
        const f = this.filtros;
        return f.tipoConta !== '-1' || !!f.idProjeto || !!f.faixaLivre || !!f.faixaDiferenca || f.soComAplicacao || f.soComCompromisso;
      },
      ateDataIso() {
        return this.ateData ? moment(this.ateData).format('YYYY-MM-DD') : '';
      },
      minimoAteData() {
        return this.painel.inicioCompromissosIso ? moment(this.painel.inicioCompromissosIso, 'YYYY-MM-DD').startOf('day').toDate() : null;
      },
      dataReferenciaIso() {
        return this.dataReferencia ? moment(this.dataReferencia).format('YYYY-MM-DD') : '';
      },
      paginas() {
        const total = this.painel.totalPaginas || 1;
        const atual = this.painel.pagina || 1;
        const ini = Math.max(1, Math.min(atual - 2, total - 4));
        const fim = Math.min(total, ini + 4);
        const lista = [];
        for (let p = ini; p <= fim; p++) lista.push(p);
        return lista;
      },
      infoPaginacao() {
        const total = this.painel.totalRegistros || 0;
        if (!total) return '';
        const por = this.painel.registrosPorPagina || 25;
        const ini = (this.painel.pagina - 1) * por + 1;
        const fim = Math.min(total, ini + por - 1);
        return ini + '–' + fim + ' de ' + total + (total === 1 ? ' conta' : ' contas') + ' · ' + por + ' por página';
      },
      rotuloData() {
        return this.painel.dataReferencia ? this.painel.dataReferencia.substr(0, 5) : 'D-1';
      },
      resumoCabecalho() {
        const r = this.resumo;
        const partes = [];
        const contas = r.contas || 0;
        if (this.filtros.card) partes.push(contas + ' de ' + (this.painel.totalContas || 0) + ' contas');
        else partes.push(contas + (contas === 1 ? ' conta' : ' contas') + (this.filtros.situacaoConta === '0' ? ' ativas' : ''));
        if (this.painel.dataReferencia) {
          partes.push('posição de ' + this.painel.diaSemanaReferencia + ' ' + this.painel.dataReferencia
            + (this.painel.rotuloReferencia ? ' (' + this.painel.rotuloReferencia + ')' : ''));
        }
        return partes.join(' · ');
      },
    },
    watch: {
      'filtros.ordem'(valor) {
        if (valor !== 'diferenca') this.ordemAntesDivergentes = null;
      },
      'filtros.banco'() {
        if (this.filtros.idConta) this.$set(this.filtros, 'idConta', '');
        this.$nextTick(() => $('#tesContaFiltro').val('').trigger('change.select2'));
      },
      dataReferencia() {
        this.lista(1);
      },
      ateData(valor) {
        if (valor) this.horizonte = 0;
        this.lista(1);
      },
      filtros: {
        deep: true,
        handler() {
          this.salvarFiltros();
          this.agendarLista();
        },
      },
    },
    mounted() {
      this.$root.tituloDaPagina = 'Posição de Tesouraria';

      const _this = this;
      $('#tesContaFiltro').select2({ theme: 'bootstrap', placeholder: '🔍  Digite para buscar uma conta...', allowClear: true, language: 'pt-BR', minimumInputLength: 0 })
        .change(function () { _this.$set(_this.filtros, 'idConta', this.value || ''); });
      $('#tesProjetoFiltro').select2({ theme: 'bootstrap', placeholder: '🔍  Digite para buscar um projeto...', allowClear: true, language: 'pt-BR', minimumInputLength: 0 })
        .change(function () { _this.$set(_this.filtros, 'idProjeto', this.value || ''); });

      this.maisFiltros = this.temMaisFiltros;

      conciliacaoProjetoServico.cabecalhoTesouraria(this.horizonte, this.ateDataIso).then(c => {
        if (this.carregando) this.painel = Object.assign({}, this.painel, c);
        if (!this.horizonte && !this.ateData && c.horizonte) this.horizonte = c.horizonte;
      }).catch(() => { });

      conciliacaoProjetoServico.contasTesouraria().then(c => {
        this.listaContas = c || [];
        this.$nextTick(() => $('#tesContaFiltro').val(this.filtros.idConta || '').trigger('change.select2'));
      });
      conciliacaoProjetoServico.projetosTesouraria().then(p => {
        this.listaProjetos = p || [];
        this.$nextTick(() => $('#tesProjetoFiltro').val(this.filtros.idProjeto || '').trigger('change.select2'));
      });

      this.lista(1);

      if (this.$route.query.conta) this.contaDetalhe = this.$route.query.conta;
    },
    beforeDestroy() {
      clearTimeout(this.timerFiltro);
      $('#tesContaFiltro').select2('destroy');
      $('#tesProjetoFiltro').select2('destroy');
    },
    methods: {
      sairDesktop() { desktopEmbed.fechar(); },
      painelVazio() {
        return { resumo: {}, totais: {}, registros: [], totalRegistros: 0, totalPaginas: 1, registrosPorPagina: 25, pagina: 1, bancos: [], totalContas: 0 };
      },
      camposFiltros() {
        return {
          card: '', idConta: '', banco: '', tipoConta: '-1', situacaoConta: '0', idProjeto: '',
          faixaLivre: '', faixaDiferenca: '', soComAplicacao: false, soComCompromisso: false, ordem: '',
        };
      },
      carregarFiltros() {
        try {
          if (!this.$route.query.voltar) {
            sessionStorage.removeItem(CHAVE_FILTROS);
            return this.camposFiltros();
          }
          const s = sessionStorage.getItem(CHAVE_FILTROS);
          return s ? Object.assign(this.camposFiltros(), JSON.parse(s)) : this.camposFiltros();
        } catch (e) { return this.camposFiltros(); }
      },
      salvarFiltros() {
        try { sessionStorage.setItem(CHAVE_FILTROS, JSON.stringify(this.filtros)); } catch (e) { }
      },
      parametros() {
        const f = this.filtros;
        return {
          dataReferencia: this.dataReferenciaIso,
          horizonte: this.horizonte,
          ateData: this.ateDataIso,
          card: f.card,
          idConta: f.idConta,
          banco: f.banco,
          tipoConta: f.tipoConta,
          situacaoConta: f.situacaoConta,
          idProjeto: f.idProjeto,
          faixaLivre: f.faixaLivre,
          faixaDiferenca: f.faixaDiferenca,
          soComAplicacao: f.soComAplicacao,
          soComCompromisso: f.soComCompromisso,
          ordem: f.ordem,
        };
      },
      lista(pagina = 1) {
        this.carregando = !this.registros.length;
        return conciliacaoProjetoServico.posicaoTesouraria(pagina, this.parametros())
          .then(dados => {
            this.painel = dados || this.painelVazio();
            this.carregando = false;
            if (!this.ateData && this.painel.horizonte) this.horizonte = this.painel.horizonte;
          })
          .catch(res => {
            this.carregando = false;
            toastr.error(res && res.body && res.body.message ? res.body.message : 'Não foi possível carregar a posição de tesouraria.');
          });
      },
      agendarLista() {
        clearTimeout(this.timerFiltro);
        this.timerFiltro = setTimeout(() => this.lista(1), 250);
      },
      irPagina(p) {
        if (p < 1 || p > this.painel.totalPaginas || p === this.painel.pagina) return;
        this.lista(p).then(() => this.$nextTick(() => { if (this.$refs.corpo) this.$refs.corpo.scrollTop = 0; }));
      },
      filtrarCard(card) {
        const novo = this.filtros.card === card ? '' : card;

        if (this.filtros.card === 'divergente' && novo !== 'divergente' && this.ordemAntesDivergentes !== null) {
          if (this.filtros.ordem === 'diferenca') this.$set(this.filtros, 'ordem', this.ordemAntesDivergentes);
          this.ordemAntesDivergentes = null;
        }

        this.$set(this.filtros, 'card', novo);

        if (novo === 'divergente' && !this.filtros.ordem) {
          this.ordemAntesDivergentes = this.filtros.ordem;
          this.$set(this.filtros, 'ordem', 'diferenca');
        }
      },
      trocarHorizonte(h) {
        if (this.horizonte === h && !this.ateData) return;
        this.horizonte = h;
        if (this.ateData) {
          this.ateData = null;
          return;
        }
        this.lista(1);
      },
      limparFiltros() {
        this.filtros = this.camposFiltros();
        this.$nextTick(() => {
          $('#tesContaFiltro').val('').trigger('change.select2');
          $('#tesProjetoFiltro').val('').trigger('change.select2');
        });
      },
      abrirConfiguracao() { this.mostrarConfiguracao = true; },
      fecharConfiguracao() { this.mostrarConfiguracao = false; },
      aoSalvarConfiguracao() {
        this.mostrarConfiguracao = false;
        if (!this.ateData) this.horizonte = 0;
        this.lista(this.painel.pagina);
      },
      abrirCompromissos(r, categoria) {
        this.compromissosCategoria = categoria;
        this.compromissosConta = r;
      },
      fecharCompromissos() { this.compromissosConta = null; },
      abrirDetalhe(r) { this.contaDetalhe = r.idContaCript; },
      abrirListaBanco() { this.$router.push({ name: 'conciliacao-banco' }); },
      abrirConciliacao(r) {
        this.$router.push({ name: 'conciliacao-banco.tela', params: { idContaCript: r.idContaCript }, query: { origem: 'tesouraria' } });
      },
      fecharDetalhe() { this.contaDetalhe = ''; },
      abrirAplicacoes(r) { this.aplicacoesConta = r; },
      moeda(v) {
        const n = v || 0;
        const texto = Math.abs(n).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        return (n < -0.004 ? '−R$ ' : 'R$ ') + texto;
      },
      moedaSinal(v) {
        const n = v || 0;
        return (n > 0.004 ? '+' : '') + this.moeda(n);
      },
      compacto(v) {
        const n = Math.abs(v || 0);
        if (n >= 1000000) return 'R$ ' + (n / 1000000).toLocaleString('pt-BR', { maximumFractionDigits: 2 }) + ' mi';
        if (n >= 1000) return 'R$ ' + Math.round(n / 1000).toLocaleString('pt-BR') + ' mil';
        return this.moeda(n);
      },
      temBanco(r) { return r.saldoBanco !== null && r.saldoBanco !== undefined && r.dataSaldoBanco > 0; },
      extratoAtrasado(r) { return this.temBanco(r) && r.dataSaldoBancoTexto !== this.rotuloData; },
      situacao(r) {
        switch (r.situacao) {
          case 'divergente': return { txt: 'Divergente', cls: 'st-diverg' };
          case 'pendente': return { txt: 'Conciliação pendente', cls: 'st-pendente' };
          case 'baixa': return { txt: 'Baixa pendente', cls: 'st-baixa' };
          case 'semextrato': return { txt: 'Sem extrato', cls: 'st-semext' };
          case 'semaplicacao': return { txt: 'Sem aplicação', cls: 'st-parado' };
          case 'sobra': return { txt: 'Sobra p/ aplicar', cls: 'st-livre' };
          default: return { txt: 'Em dia', cls: 'st-ok' };
        }
      },
      tituloSituacao(r) {
        const s = [];
        if (r.divergente) s.push('Diferença de ' + this.moedaSinal(r.divergencia) + ' com a conta conciliada (' + r.tipoDivergencia + ')');
        if (r.conciliacaoPendente) s.push('Diferença de ' + this.moedaSinal(r.divergencia) + ' com conciliação pendente: ' + this.textoPendencias(r));
        if (r.baixaPendente) s.push(r.qtdeBaixaPendente + ' título(s) em borderô com arquivo enviado e sem baixa: ' + this.moeda(r.valorBaixaPendente));
        if (r.semExtrato) s.push('Sem extrato desde ' + r.ultimoExtratoTexto);
        if (r.aplicacoesParadas > 0) s.push('Aplicação sem movimento há ' + r.diasAplicacaoParada + ' dias');
        if (r.tratadaEm) s.push('Tratada em ' + r.tratadaEm + (r.tratadaPor ? ' por ' + r.tratadaPor : ''));
        return s.join('\n');
      },
      textoPendencias(r) {
        const partes = [];
        if (r.lancamentosPorConciliar) partes.push(r.lancamentosPorConciliar + (r.lancamentosPorConciliar === 1 ? ' lançamento não conferido' : ' lançamentos não conferidos'));
        if (r.extratosPorConciliar) partes.push(r.extratosPorConciliar + (r.extratosPorConciliar === 1 ? ' linha de extrato' : ' linhas de extrato') + ' por conciliar');
        if (!partes.length && r.extratosPendentes) partes.push(r.extratosPendentes + ' linha(s) de extrato com lançamento ainda não conferido');
        return partes.join(' e ') + ' (mesma contagem da Conciliação de Banco)';
      },
      tituloDivergencia(r) {
        if (r.conciliacaoPendente) return 'Conciliação pendente: ' + this.textoPendencias(r);
        const t = {
          'baixa pendente': 'Conta conciliada, mas há borderô com arquivo enviado e títulos sem baixa',
          'estrutural': 'Conta conciliada e ainda assim diferente do banco: diferença a investigar',
        };
        return t[r.tipoDivergencia] || '';
      },
      iconeDivergencia(r) {
        if (r.conciliacaoPendente) return 'fa-hourglass-half';
        return r.tipoDivergencia === 'baixa pendente' ? 'fa-clock-o' : 'fa-exclamation-triangle';
      },
      corDivergencia(r) {
        if (r.conciliacaoPendente) return 'div-laranja';
        return r.tipoDivergencia === 'baixa pendente' ? 'div-roxo' : 'div-vermelho';
      },
      tituloCompromissos(r) {
        return 'Previstos ' + this.moeda(r.previstos) + ' · Em borderô ' + this.moeda(r.emBordero)
          + '\nVencendo sem previsão ' + this.moeda(r.vencendoSemPrevisao)
          + '\nAtrasados, ainda não pagos ' + this.moeda(r.atrasados) + (r.qtdeAtrasados ? ' (' + r.qtdeAtrasados + ')' : '')
          + '\n' + r.qtdeTitulos + ' título(s)';
      },
      tituloLivre(r) {
        let t = r.fonteSaldo === 'extrato'
          ? 'Pelo banco: saldo do extrato de ' + r.dataSaldoBancoTexto + ' ' + this.moeda(r.saldoBanco)
            + (Math.abs(r.movimentoAposExtrato) >= 0.01 ? ' ' + this.moedaSinal(r.movimentoAposExtrato) + ' conciliado no Manager depois' : '')
            + '\n= ' + this.moeda(r.saldoBase) + ' − compromissos ' + this.moeda(r.compromissos)
          : 'Saldo conciliado no Manager ' + this.moeda(r.saldoBase) + ' − compromissos ' + this.moeda(r.compromissos);
        if (r.livreCoberto) t += '\nCoberto por resgate automático: não entra em "Sobra para aplicar"';
        return t;
      },
      tituloSaldo(r) {
        let t = 'Saldo conciliado no Manager até o fim de ' + this.rotuloData + ' (lançamentos conferidos pela data do lançamento; antes da data de corte da conciliação, todos)'
          + '\nPor operação (todos, conferidos ou não): ' + this.moeda(r.saldoSistema);
        if (r.divergenciaOperacao) {
          t += '\nDiferença: ' + this.moedaSinal(r.diferencaOperacao);
          if (r.lancamentosNaoConferidosAteReferencia) t += ' em ' + r.lancamentosNaoConferidosAteReferencia + (r.lancamentosNaoConferidosAteReferencia === 1 ? ' lançamento não conferido' : ' lançamentos não conferidos') + ' desde a data de corte';
        }
        return t;
      },
      clsLivre(r) {
        if (r.livreCoberto) return '';
        if (r.sobra) return 'livre-ok';
        if (r.semAplicacao) return 'livre-parado';
        return '';
      },
      tipoTexto(r) {
        if (r.tipoConta === 2) return 'Poupança';
        if (r.tipoConta === 3) return 'Bloqueio';
        return '';
      },
      exportar() {
        if (this.exportando) return;
        this.exportando = true;
        conciliacaoProjetoServico.exportarPosicaoTesouraria(this.parametros())
          .then(registros => {
            this.exportando = false;
            this.gerarCsv(registros || []);
          })
          .catch(() => {
            this.exportando = false;
            toastr.error('Não foi possível gerar o Excel.');
          });
      },
      gerarCsv(registros) {
        const num = v => (v === null || v === undefined ? '' : (+v).toFixed(2).replace('.', ','));
        const txt = v => '"' + ('' + (v === null || v === undefined ? '' : v)).replace(/"/g, '""') + '"';
        const cab = ['Conta', 'Banco', 'Agência', 'C/C', 'Base do livre', 'Fonte da base do livre', 'Conciliado no Manager', 'Operação no Manager', 'Conciliado ' + this.rotuloData, 'Banco', 'Data saldo banco',
          'Diferença', 'Tipo da diferença', 'Previstos', 'Em borderô', 'Vencendo sem previsão', 'Atrasados', 'Compromissos', 'Aplicado',
          'Livre para aplicar', 'Coberto por resgate automático', 'Situação'];
        const linhas = [cab.map(txt).join(';')];
        registros.forEach(r => {
          linhas.push([
            txt(r.nomeConta), txt(r.nomeBanco), txt(r.numeroAgencia), txt(r.numeroConta), num(r.saldoBase), txt(r.fonteSaldo === 'extrato' ? 'extrato ' + r.dataSaldoBancoTexto : 'conciliado no Manager'), num(r.saldoCompensado), num(r.saldoSistema), num(r.saldoConciliado),
            num(r.saldoBanco), txt(r.dataSaldoBancoTexto), num(r.divergencia), txt(r.tipoDivergencia || ''), num(r.previstos),
            num(r.emBordero), num(r.vencendoSemPrevisao), num(r.atrasados), num(r.compromissos), num(r.saldoAplicado), num(r.saldoLivre),
            txt(r.livreCoberto ? 'sim' : ''), txt(this.situacao(r).txt),
          ].join(';'));
        });
        const blob = new Blob(['﻿' + linhas.join('\r\n')], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'posicao-tesouraria-' + moment().format('DD-MM-YYYY') + '.csv';
        link.click();
        URL.revokeObjectURL(url);
      },
    },
  };
</script>

<template>
  <div>
  <div class="lst-page">
  <div class="lst-card">

    <div class="lst-topo">
      <div class="lst-head">
        <div>
          <div class="lst-tit">Posição de Tesouraria</div>
          <div class="lst-res">{{ resumoCabecalho }}</div>
        </div>
        <div class="head-ctl">
          <div class="ctl-grp">
            <span class="ctl-lbl">Data de referência</span>
            <div class="ref-fixa" title="Definida em Configurações">
              <i class="fa fa-calendar"></i>
              <span class="mono">{{ painel.dataReferencia || '—' }}</span>
              <small>{{ painel.diaSemanaReferencia }} · {{ painel.rotuloReferencia || 'D-1 útil' }}</small>
            </div>
          </div>
          <div class="ctl-grp">
            <span class="ctl-lbl">Compromissos até</span>
            <div class="seg">
              <button type="button" :class="{ ativo: horizonte === -1 }" @click="trocarHorizonte(-1)" title="Só a própria data de referência">Dia</button>
              <button type="button" :class="{ ativo: horizonte === 1 }" @click="trocarHorizonte(1)" title="Primeiro dia útil depois da data de referência">D+1</button>
              <button type="button" :class="{ ativo: horizonte === 2 }" @click="trocarHorizonte(2)" title="Dois dias úteis depois da data de referência">D+2</button>
              <button type="button" :class="{ ativo: horizonte === 3 }" @click="trocarHorizonte(3)" title="Três dias úteis depois da data de referência">D+3</button>
              <button type="button" :class="{ ativo: horizonte === 5 }" @click="trocarHorizonte(5)" title="Cinco dias úteis depois da data de referência">Semana</button>
            </div>
          </div>
          <div class="ctl-grp">
            <span class="ctl-lbl">ou até a data</span>
            <div class="dt-ate">
              <date-picker v-model="ateData" format="DD/MM/YYYY" lang="pt-br" input-class="form-control input-sm dt-ref"
                           placeholder="escolher data" :editable="false" :shortcuts="false" :clearable="true" :not-before="minimoAteData"></date-picker>
            </div>
          </div>
        </div>
      </div>

      <div class="kpi-faixa">
        <button type="button" class="kpi-card kpi-todas" :class="{ ativo: !filtros.card }" @click="filtrarCard('')">
          <div class="kpi-lbl"><span class="kpi-dot"></span> Todas as contas</div>
          <div class="kpi-val"><span class="kpi-num">{{ resumo.contas || 0 }}</span><span class="kpi-qlf">{{ filtros.situacaoConta === '0' ? 'ativas' : 'no filtro' }}</span></div>
        </button>
        <button type="button" class="kpi-card kpi-livre" :class="{ ativo: filtros.card === 'sobra' }" @click="filtrarCard('sobra')"
                :title="'Livre para aplicar ≥ ' + moeda(painel.valorMinimo) + ', com aplicação ativa sem resgate automático'">
          <div class="kpi-lbl"><span class="kpi-dot"></span> Sobra para aplicar</div>
          <div class="kpi-val"><span class="kpi-num">{{ resumo.sobra || 0 }}</span><span class="kpi-qlf">{{ compacto(resumo.valorSobra) }} livres</span></div>
        </button>
        <button type="button" class="kpi-card kpi-parado" :class="{ ativo: filtros.card === 'semaplicacao' }" @click="filtrarCard('semaplicacao')"
                :title="'Livre para aplicar ≥ ' + moeda(painel.valorMinimo) + ', sem nenhuma aplicação ativa'">
          <div class="kpi-lbl"><span class="kpi-dot"></span> Saldo sem aplicação</div>
          <div class="kpi-val"><span class="kpi-num">{{ resumo.semAplicacao || 0 }}</span><span class="kpi-qlf">{{ compacto(resumo.valorSemAplicacao) }} parados</span></div>
        </button>
        <button type="button" class="kpi-card kpi-operacao" :class="{ ativo: filtros.card === 'operacao' }" @click="filtrarCard('operacao')"
                title="Contas com lançamento feito e ainda não conciliado desde a data de corte: o saldo por operação não bate com o conciliado">
          <div class="kpi-lbl"><span class="kpi-dot"></span> Em conciliação</div>
          <div class="kpi-val"><span class="kpi-num">{{ resumo.divergenciaOperacao || 0 }}</span><span class="kpi-qlf">{{ compacto(resumo.valorDivergenciaOperacao) }} operação × conciliado</span></div>
        </button>
        <button type="button" class="kpi-card kpi-pendente" :class="{ ativo: filtros.card === 'pendente' }" @click="filtrarCard('pendente')"
                title="Banco diferente do Manager, mas a conta ainda tem lançamentos ou linhas de extrato por conciliar (mesma contagem da Conciliação de Banco)">
          <div class="kpi-lbl"><span class="kpi-dot"></span> Conciliação pendente</div>
          <div class="kpi-val"><span class="kpi-num">{{ resumo.conciliacaoPendente || 0 }}</span><span class="kpi-qlf">{{ compacto(resumo.valorConciliacaoPendente) }} a explicar</span></div>
        </button>
        <button type="button" class="kpi-card kpi-diverg" :class="{ ativo: filtros.card === 'divergente' }" @click="filtrarCard('divergente')"
                title="Conta conciliada (nada pendente na Conciliação de Banco) e ainda assim diferente do banco">
          <div class="kpi-lbl"><span class="kpi-dot"></span> Divergentes</div>
          <div class="kpi-val"><span class="kpi-num">{{ resumo.divergentes || 0 }}</span><span class="kpi-qlf">{{ compacto(resumo.valorDivergente) }} de diferença</span></div>
        </button>
        <button type="button" class="kpi-card kpi-semext" :class="{ ativo: filtros.card === 'semextrato' }" @click="filtrarCard('semextrato')"
                title="Contas cujo extrato informa saldo e que não tiveram linha no último dia útil">
          <div class="kpi-lbl"><span class="kpi-dot"></span> Sem extrato</div>
          <div class="kpi-val"><span class="kpi-num">{{ resumo.semExtrato || 0 }}</span><span class="kpi-qlf">{{ resumo.semExtratoDesde ? 'desde ' + resumo.semExtratoDesde : 'em dia' }}</span></div>
        </button>
        <button type="button" class="kpi-card kpi-baixa" :class="{ ativo: filtros.card === 'baixa' }" @click="filtrarCard('baixa')"
                title="Títulos em borderô com arquivo enviado ao banco e ainda sem baixa no sistema">
          <div class="kpi-lbl"><span class="kpi-dot"></span> Baixa pendente</div>
          <div class="kpi-val"><span class="kpi-num">{{ resumo.baixaPendente || 0 }}</span><span class="kpi-qlf">{{ compacto(resumo.valorBaixaPendente) }} em borderô enviado</span></div>
        </button>
      </div>

      <div class="ibox">
        <div class="ibox-title"><h5><i class="fa fa-filter"></i> Filtros</h5>
          <div class="ibox-tools">
            <button type="button" class="btn" :class="temFiltro ? 'btn-warning' : 'btn-white'" :disabled="!temFiltro" @click="limparFiltros"><i class="fa fa-eraser"></i> Limpar filtros</button>
          </div>
        </div>
        <div class="ibox-content">
          <div class="filtro-linha filtro-l1">
            <div class="form-group">
              <label class="control-label">Conta</label>
              <select id="tesContaFiltro" class="form-control" style="width:100%">
                <option value=""></option>
                <option v-for="c in contasDoBanco" :key="c.idCript" :value="c.idCript">{{ c.nome }}</option>
              </select>
            </div>
            <div class="form-group">
              <label class="control-label">Banco</label>
              <select class="form-control" v-model="filtros.banco">
                <option value="">Todos os bancos</option>
                <option v-for="b in painel.bancos" :key="b" :value="b">{{ b }}</option>
              </select>
            </div>
            <div class="form-group">
              <label class="control-label">Situação da conta</label>
              <div class="seg seg-full">
                <button type="button" :class="{ ativo: filtros.situacaoConta === '0' }" @click="filtros.situacaoConta = '0'">Ativas</button>
                <button type="button" :class="{ ativo: filtros.situacaoConta === '1' }" @click="filtros.situacaoConta = '1'">Encerradas</button>
                <button type="button" :class="{ ativo: filtros.situacaoConta === '2' }" @click="filtros.situacaoConta = '2'">Todas</button>
              </div>
            </div>
            <div class="form-group">
              <label class="control-label">Ordenar por</label>
              <select class="form-control" v-model="filtros.ordem">
                <option value="">Livre para aplicar (maior primeiro)</option>
                <option value="diferenca">Diferença (maior primeiro)</option>
                <option value="saldo">Saldo no Manager (maior primeiro)</option>
                <option value="aplicado">Aplicado (maior primeiro)</option>
                <option value="conta">Conta (A–Z)</option>
              </select>
            </div>
            <div class="form-group mf-grupo">
              <button type="button" class="mais-filtros" @click="maisFiltros = !maisFiltros">
                <i class="fa" :class="maisFiltros ? 'fa-angle-down' : 'fa-angle-right'"></i> {{ maisFiltros ? 'Menos filtros' : 'Mais filtros' }}
                <span v-if="!maisFiltros && temMaisFiltros" class="mf-dot"></span>
              </button>
            </div>
          </div>

          <div v-show="maisFiltros">
            <div class="filtro-linha filtro-l2">
              <div class="form-group">
                <label class="control-label">Tipo de conta</label>
                <select class="form-control" v-model="filtros.tipoConta">
                  <option value="-1">Todos</option>
                  <option value="0">Corrente</option>
                  <option value="2">Poupança</option>
                  <option value="3">Bloqueio</option>
                </select>
              </div>
              <div class="form-group">
                <label class="control-label">Projeto</label>
                <select id="tesProjetoFiltro" class="form-control" style="width:100%">
                  <option value=""></option>
                  <option v-for="p in listaProjetos" :key="p.idCript" :value="p.idCript">{{ p.nome }}</option>
                </select>
              </div>
              <div class="form-group">
                <label class="control-label">Faixa do livre para aplicar</label>
                <div class="seg seg-full">
                  <button type="button" :class="{ ativo: !filtros.faixaLivre }" @click="filtros.faixaLivre = ''">Todas</button>
                  <button type="button" :class="{ ativo: filtros.faixaLivre === '1mi' }" @click="filtros.faixaLivre = '1mi'">≥ 1 mi</button>
                  <button type="button" :class="{ ativo: filtros.faixaLivre === '100mil' }" @click="filtros.faixaLivre = '100mil'">100 mil a 1 mi</button>
                  <button type="button" :class="{ ativo: filtros.faixaLivre === '10mil' }" @click="filtros.faixaLivre = '10mil'">10 a 100 mil</button>
                  <button type="button" :class="{ ativo: filtros.faixaLivre === 'menor' }" @click="filtros.faixaLivre = 'menor'">&lt; 10 mil</button>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label">Faixa da diferença</label>
                <div class="seg seg-full">
                  <button type="button" :class="{ ativo: !filtros.faixaDiferenca }" @click="filtros.faixaDiferenca = ''">Todas</button>
                  <button type="button" :class="{ ativo: filtros.faixaDiferenca === '1mi' }" @click="filtros.faixaDiferenca = '1mi'">≥ 1 mi</button>
                  <button type="button" :class="{ ativo: filtros.faixaDiferenca === '100mil' }" @click="filtros.faixaDiferenca = '100mil'">100 mil a 1 mi</button>
                  <button type="button" :class="{ ativo: filtros.faixaDiferenca === '10mil' }" @click="filtros.faixaDiferenca = '10mil'">10 a 100 mil</button>
                  <button type="button" :class="{ ativo: filtros.faixaDiferenca === 'menor' }" @click="filtros.faixaDiferenca = 'menor'">&lt; 10 mil</button>
                </div>
              </div>
            </div>
            <div class="chk-linha">
              <label class="checkbox-inline"><input type="checkbox" v-model="filtros.soComAplicacao"> Só com aplicação ativa</label>
              <label class="checkbox-inline"><input type="checkbox" v-model="filtros.soComCompromisso"> Só com compromisso no horizonte</label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="lst-corpo" ref="corpo">
      <table class="table tabela-tes">
        <thead>
          <tr>
            <th>Conta</th>
            <th class="r sep" title="Saldo dos lançamentos conferidos (conciliados) no Manager até o fim da data de referência">Saldo em {{ rotuloData }}</th>
            <th class="r" title="Último saldo lido no extrato do banco até a data de referência">Extrato em {{ rotuloData }}</th>
            <th class="r">Diferença</th>
            <th class="r sep" :title="'Contas a pagar em aberto com previsão (ou vencimento) antes de ' + painel.inicioCompromissos + ', dentro da janela configurada'">Atrasados</th>
            <th class="r" :title="'Contas a pagar com previsão ou, sem previsão, vencimento de ' + painel.inicioCompromissos + ' a ' + painel.limite">A pagar até {{ painel.limite }}</th>
            <th class="r" title="Títulos em borderô aberto">Em borderô</th>
            <th class="r" title="Solicitações de transferência liberadas e lançamentos de transferência ainda não pagos">Transferências</th>
            <th class="r">Aplicado</th>
            <th class="r">Livre para aplicar</th>
            <th class="sep">Situação</th>
            <th class="r col-acoes">Ações</th>
          </tr>
        </thead>
        <tbody v-if="!carregando">
          <tr v-for="r in registros" :key="r.idContaCript" :class="{ sel: contaDetalhe === r.idContaCript }">
            <td class="c-conta">
              {{ r.nomeConta }}
              <span class="agcc mono">Ag {{ r.numeroAgencia }} · C/C {{ r.numeroConta }}</span>
              <span v-if="tipoTexto(r)" class="chip chip-cinza">{{ tipoTexto(r) }}</span>
              <span v-if="r.encerrada" class="chip chip-vermelho">encerrada</span>
              <span class="sub">{{ r.nomeBanco }}</span>
            </td>
            <td class="r num sep" :title="tituloSaldo(r)">
              <span :class="{ neg: r.saldoCompensado < 0 }">{{ moeda(r.saldoCompensado) }}</span>
              <span class="sub">conciliado no Manager</span>
              <span v-if="r.divergenciaOperacao" class="sub sub-op"><i class="fa fa-exclamation-circle"></i> operação {{ moeda(r.saldoSistema) }}</span>
            </td>
            <td class="r num">
              <template v-if="temBanco(r)">
                <span :class="{ neg: r.saldoBanco < 0 }">{{ moeda(r.saldoBanco) }}</span>
                <span class="sub" :class="{ 'sub-azul': extratoAtrasado(r) }">lido em {{ r.dataSaldoBancoTexto }}</span>
              </template>
              <template v-else>
                <span class="mudo">—</span>
                <span class="sub">sem saldo no extrato</span>
              </template>
            </td>
            <td class="r num">
              <span v-if="!temBanco(r)" class="mudo">—</span>
              <span v-else-if="!r.divergente && !r.conciliacaoPendente" class="ok">R$ 0,00</span>
              <span v-else class="div-cel" :title="tituloDivergencia(r)">
                <span :class="r.conciliacaoPendente ? 'pend-val' : 'neg'">{{ moedaSinal(r.divergencia) }}</span>
                <i class="fa" :class="[iconeDivergencia(r), corDivergencia(r)]"></i>
              </span>
            </td>
            <td v-for="(col, ci) in colunasCompromisso" :key="col.categoria" class="r num" :class="{ sep: ci === 0 }">
              <button v-if="col.valor(r) > 0.004" type="button" class="lnk-valor" :class="col.cls"
                      :title="'Conferir os lançamentos: ' + col.titulo" @click="abrirCompromissos(r, col.categoria)">{{ moeda(col.valor(r)) }}</button>
              <span v-else class="mudo">R$ 0,00</span>
              <span v-if="col.qtde(r)" class="sub">{{ col.qtde(r) }} {{ col.qtde(r) === 1 ? 'lançamento' : 'lançamentos' }}</span>
            </td>
            <td class="r num">
              <span v-if="r.saldoAplicado > 0.004 || r.qtdeAplicacoes">{{ moeda(r.saldoAplicado) }}</span>
              <span v-else class="mudo">R$ 0,00</span>
            </td>
            <td class="r num" :class="clsLivre(r)" :title="tituloLivre(r)">
              <template v-if="r.livreCoberto">
                <span class="livre livre-coberto">{{ moeda(r.saldoLivre) }} <i class="fa fa-info-circle"></i></span>
                <span class="sub">resgate automático</span>
              </template>
              <template v-else-if="r.saldoLivre > 0.004">
                <span class="livre">{{ moeda(r.saldoLivre) }}</span>
                <span v-if="r.fonteSaldo === 'extrato'" class="sub sub-azul">pelo banco</span>
              </template>
              <span v-else class="livre mudo">R$ 0,00</span>
            </td>
            <td class="sep" :title="tituloSituacao(r)">
              <span class="st" :class="situacao(r).cls">{{ situacao(r).txt }}</span>
              <span v-if="r.tratadaEm" class="sub sub-ok"><i class="fa fa-check"></i> tratada</span>
            </td>
            <td class="r col-acoes">
              <div class="acoes-linha">
                <button type="button" class="btn-ver" title="Ver o detalhe da conta" @click="abrirDetalhe(r)"><i class="fa fa-eye"></i> Visualizar</button>
                <button v-if="podeConciliarBanco" type="button" class="btn-conciliar" title="Abrir a conciliação desta conta" @click="abrirConciliacao(r)"><i class="fa fa-university"></i> Financeiro</button>
                <button type="button" class="btn-aplic" title="Aplicações da conta" @click="abrirAplicacoes(r)"><i class="fa fa-line-chart"></i></button>
              </div>
            </td>
          </tr>
          <tr v-if="registros.length === 0">
            <td colspan="12" class="vazio-lista">
              <i class="fa fa-search-minus"></i>
              <div class="vz-t">Nenhuma conta nesta condição</div>
              <div class="vz-s">Ajuste os filtros ou clique em outro card para ver mais contas.</div>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr v-for="n in 6" :key="'sk' + n" class="skel-linha">
            <td><div class="skel" style="width:180px"></div><div class="skel" style="width:130px;height:9px;margin-top:6px"></div></td>
            <td v-for="k in 9" :key="'c' + k" class="r"><div class="skel" style="width:80px;margin-left:auto"></div></td>
            <td><div class="skel" style="width:110px"></div></td>
            <td class="r"><div class="skel" style="width:90px;margin-left:auto"></div></td>
          </tr>
        </tbody>
        <tfoot v-if="!carregando && registros.length">
          <tr>
            <td>Totais do filtro atual</td>
            <td class="r num sep">{{ moeda(totais.saldoCompensado) }}</td>
            <td class="r num">{{ moeda(totais.saldoBanco) }}</td>
            <td class="r num">{{ moedaSinal(totais.divergencia) }}</td>
            <td class="r num sep">{{ moeda(totais.atrasados) }}</td>
            <td class="r num">{{ moeda(totais.aPagar) }}</td>
            <td class="r num">{{ moeda(totais.emBordero) }}</td>
            <td class="r num">{{ moeda(totais.transferencias) }}</td>
            <td class="r num">{{ moeda(totais.saldoAplicado) }}</td>
            <td class="r num" title="Não soma o livre já coberto por resgate automático">{{ moeda(totais.saldoLivre) }}</td>
            <td class="sep"></td>
            <td class="col-acoes"></td>
          </tr>
        </tfoot>
      </table>
    </div>

    <div class="rodape">
      <div class="rodape-l">
        <button v-if="podeConfigurar" type="button" class="btn btn-white" @click="abrirConfiguracao"><i class="fa fa-cog"></i> Configurações</button>
      </div>
      <div class="rodape-c">
        <div class="pag" v-if="painel.totalRegistros > 0">
          <button v-if="painel.totalPaginas > 1" type="button" :disabled="painel.pagina <= 1" aria-label="Anterior" @click="irPagina(painel.pagina - 1)"><i class="fa fa-angle-left"></i></button>
          <button v-for="p in paginas" :key="'p' + p" type="button" :class="{ ativo: p === painel.pagina }" @click="irPagina(p)">{{ p }}</button>
          <button v-if="painel.totalPaginas > 1" type="button" :disabled="painel.pagina >= painel.totalPaginas" aria-label="Próxima" @click="irPagina(painel.pagina + 1)"><i class="fa fa-angle-right"></i></button>
        </div>
        <span class="pag-info">{{ infoPaginacao }}</span>
      </div>
      <div class="rodape-r">
        <button v-if="podeConciliarBanco" type="button" class="btn btn-white" @click="abrirListaBanco" title="Abre a lista da Conciliação de Banco"><i class="fa fa-list"></i> Conciliação de Banco</button>
        <button type="button" class="btn btn-primary" :disabled="exportando || !painel.totalRegistros" @click="exportar">
          <i class="fa" :class="exportando ? 'fa-spinner fa-pulse' : 'fa-file-excel-o'"></i> {{ exportando ? 'Exportando...' : 'Exportar Excel' }}
        </button>
        <button v-if="temDesktop" type="button" class="btn btn-sair" @click="sairDesktop" title="Fecha esta janela do Manager">
          <i class="fa fa-sign-out"></i> Sair
        </button>
      </div>
    </div>

  </div>
  </div>

    <configuracao-credito-modal v-if="mostrarConfiguracao && podeConfigurar" secao-inicial="tesouraria"
      @fechar="fecharConfiguracao" @salvo="aoSalvarConfiguracao"></configuracao-credito-modal>

    <posicao-tesouraria-compromissos v-if="compromissosConta" :conta="compromissosConta" :categoria-inicial="compromissosCategoria"
      :data-referencia="dataReferenciaIso" :horizonte="horizonte" :ate-data="ateDataIso" :limite="painel.limite" @fechar="fecharCompromissos"></posicao-tesouraria-compromissos>
    <aplicacoes-conta-modal v-if="aplicacoesConta" :conta="aplicacoesConta" @fechar="aplicacoesConta = null"></aplicacoes-conta-modal>

    <posicao-tesouraria-detalhe v-if="contaDetalhe" :key="contaDetalhe + dataReferenciaIso + horizonte + ateDataIso"
      :id-conta-cript="contaDetalhe" :data-referencia="dataReferenciaIso" :horizonte="horizonte" :ate-data="ateDataIso" :pode-tratar="podeTratar"
      @fechar="fecharDetalhe" @tratada="lista(painel.pagina)"></posicao-tesouraria-detalhe>
  </div>
</template>

<style scoped>
  .lst-page { box-sizing: border-box; position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: #eceef1; padding: 12px 14px; overflow: auto; }
  .lst-card { min-width: 1024px; height: 100%; display: flex; flex-direction: column; background: #fff; border: 1px solid #d3d8de; border-radius: 8px; box-shadow: 0 1px 2px rgba(16,24,40,.06); overflow: hidden; }
  .lst-topo { flex: 0 0 auto; }
  .lst-head { display: flex; justify-content: space-between; align-items: flex-start; padding: 11px 16px 9px; border-bottom: 1px solid #eef1f4; }
  .lst-tit { font-size: 13.5px; font-weight: 600; color: #1c2024; }
  .lst-res { font-family: 'IBM Plex Mono', Consolas, monospace; font-size: 12px; color: #6b747e; margin-top: 2px; }
  .head-ctl { display: flex; align-items: flex-end; gap: 14px; }
  .ctl-grp { display: flex; flex-direction: column; gap: 3px; }
  .ctl-lbl { font-size: 10.5px; font-weight: 600; text-transform: uppercase; letter-spacing: .05em; color: #7b848e; }
  .head-ctl >>> .mx-datepicker { width: 190px; }
  .ref-fixa { display: inline-flex; align-items: center; gap: 8px; height: 30px; padding: 0 10px; border: 1px solid #dfe3e8; border-radius: 5px; background: #f7f9fa; color: #1c2024; font-size: 12.5px; }
  .ref-fixa .fa { color: #7b848e; }
  .ref-fixa .mono { font-weight: 600; }
  .ref-fixa small { color: #8a939c; font-size: 11px; }
  .head-ctl .dt-ate >>> .mx-datepicker { width: 150px; }
  .head-ctl >>> .dt-ref { height: 30px; font-size: 12.5px; }

  .seg { display: inline-flex; border: 1px solid #c7cdd4; border-radius: 5px; overflow: hidden; height: 34px; background: #fff; }
  .seg button { border: none; background: #fff; color: #5b6570; font-size: 12.5px; padding: 0 12px; cursor: pointer; border-left: 1px solid #e2e6ea; white-space: nowrap; }
  .seg button:first-child { border-left: none; }
  .seg button:hover { background: #f4f6f8; }
  .seg button.ativo { background: #1ab394; color: #fff; font-weight: 600; }
  .seg-full { display: flex; width: 100%; height: 34px; }
  .seg-full button { flex: 1; padding: 0 6px; }

  .kpi-faixa { display: grid; grid-template-columns: repeat(8, minmax(0, 1fr)); gap: 10px; padding: 12px 16px; }
  .kpi-card { text-align: left; padding: 10px 13px; background: #fff; border: 1px solid #e6e9ed; border-radius: 7px; transition: border-color .12s, background .12s; }
  .kpi-card:hover { border-color: #c6ccd4; }
  .kpi-lbl { display: flex; align-items: center; gap: 6px; font-size: 10.5px; font-weight: 600; text-transform: uppercase; letter-spacing: .05em; color: #7b848e; }
  .kpi-dot { width: 7px; height: 7px; border-radius: 50%; background: currentColor; flex: none; }
  .kpi-val { margin-top: 4px; display: flex; align-items: baseline; gap: 6px; flex-wrap: wrap; }
  .kpi-num { font-family: 'IBM Plex Mono', Consolas, monospace; font-variant-numeric: tabular-nums; font-size: 21px; font-weight: 600; color: #1c2024; }
  .kpi-qlf { font-size: 11.5px; color: #8a939c; }
  .kpi-livre .kpi-lbl, .kpi-livre .kpi-num { color: #0a6d4d; }
  .kpi-parado .kpi-lbl, .kpi-parado .kpi-num { color: #c98a00; }
  .kpi-diverg .kpi-lbl, .kpi-diverg .kpi-num { color: #a13c3c; }
  .kpi-pendente .kpi-lbl, .kpi-pendente .kpi-num { color: #b06a15; }
  .kpi-operacao .kpi-lbl, .kpi-operacao .kpi-num { color: #2b5b8c; }
  .kpi-operacao.ativo { border-color: #5b8cc4; background: #f3f8fd; box-shadow: inset 0 0 0 1px #5b8cc4; }
  .kpi-pendente.ativo { border-color: #d9a25f; background: #fdf6ec; box-shadow: inset 0 0 0 1px #d9a25f; }
  .kpi-semext .kpi-lbl, .kpi-semext .kpi-num { color: #4f6b86; }
  .kpi-baixa .kpi-lbl, .kpi-baixa .kpi-num { color: #5b3a9e; }
  .kpi-card.ativo { border-color: #a9b2bb; background: #f7f9fa; box-shadow: inset 0 0 0 1px #a9b2bb; }
  .kpi-livre.ativo { border-color: #0f8a5f; background: #f4faf7; box-shadow: inset 0 0 0 1px #0f8a5f; }
  .kpi-parado.ativo { border-color: #c98a00; background: #fdf9ef; box-shadow: inset 0 0 0 1px #c98a00; }
  .kpi-diverg.ativo { border-color: #c98080; background: #fdf7f7; box-shadow: inset 0 0 0 1px #c98080; }
  .kpi-semext.ativo { border-color: #7f97ad; background: #f3f6f9; box-shadow: inset 0 0 0 1px #7f97ad; }
  .kpi-baixa.ativo { border-color: #9b84c9; background: #f8f5fd; box-shadow: inset 0 0 0 1px #9b84c9; }

  .lst-topo .ibox { border: none; box-shadow: none; margin: 0 16px 10px; }
  .lst-topo .ibox-content { padding-bottom: 4px; }
  .filtro-linha { display: grid; gap: 14px; align-items: end; }
  .filtro-l1 { grid-template-columns: 2.6fr 1.2fr 1.6fr 1.8fr auto; }
  .filtro-l2 { grid-template-columns: 1.1fr 2fr 2.4fr 2.4fr; }
  .filtro-linha .form-group { margin-bottom: 10px; }
  .mf-grupo { display: flex; align-items: center; justify-content: center; }
  .mais-filtros { position: relative; display: inline-flex; align-items: center; justify-content: center; gap: 6px; height: 34px; padding: 0 14px; background: #fff; border: 1px solid #c7cdd4; border-radius: 5px; color: #12876f; font-size: 13px; font-weight: 600; cursor: pointer; white-space: nowrap; }
  .mais-filtros:hover { background: #f2fbf8; border-color: #1ab394; }
  .mf-dot { width: 7px; height: 7px; border-radius: 50%; background: #f8ac59; }
  .chk-linha { display: flex; align-items: center; gap: 18px; margin-bottom: 8px; }
  .chk-linha .checkbox-inline { padding-left: 0; margin: 0; display: inline-flex; align-items: center; gap: 6px; font-size: 12.5px; }
  .chk-linha input { position: static; margin: 0; }

  .lst-corpo { flex: 1 1 auto; min-height: 0; overflow: auto; }
  .tabela-tes { width: 100%; margin: 0; }
  .tabela-tes thead th {
    position: sticky; top: 0; z-index: 2;
    background: #f7f9fa; color: #7b848e; font-weight: 600; font-size: 10.5px; text-transform: uppercase; letter-spacing: .05em;
    border-bottom: 1px solid #dfe3e8 !important; border-top: 1px solid #dfe3e8; padding: 8px 10px; white-space: nowrap;
  }
  .tabela-tes tbody td { vertical-align: middle; padding: 10px; border-top: 1px solid #f0f1f3; font-size: 12.5px; color: #34495e; }
  .tabela-tes tbody tr:nth-child(even) > td { background: #fbfcfd; }
  .tabela-tes tbody tr:hover > td, .tabela-tes tbody tr.sel > td { background: #eaf5ff; }
  .tabela-tes tfoot td { position: sticky; bottom: 0; padding: 8px 10px; border-top: 2px solid #dfe3e8; background: #f7f9fa; font-size: 12.5px; font-weight: 600; color: #1c2024; }
  .tabela-tes .r { text-align: right; }
  .tabela-tes .sep { border-left: 1px solid #eef1f4; }
  .tabela-tes .num { font-family: 'IBM Plex Mono', Consolas, monospace; font-variant-numeric: tabular-nums; white-space: nowrap; }
  .tabela-tes .sub { display: block; font-family: 'Open Sans', sans-serif; font-size: 11px; color: #8a939c; margin-top: 2px; white-space: nowrap; font-weight: 400; }
  .tabela-tes .c-conta .sub { white-space: normal; max-width: 280px; line-height: 1.35; }
  .tabela-tes .c-conta .agcc { font-size: 11px; font-weight: 400; color: #6b747e; margin-left: 6px; white-space: nowrap; }
  .tabela-tes .c-conta { min-width: 200px; max-width: 300px; }
  .tabela-tes .col-acoes { position: sticky; right: 0; z-index: 1; background: #fff; box-shadow: -6px 0 8px -6px rgba(16,24,40,.18); }
  .tabela-tes thead th.col-acoes { z-index: 3; background: #f7f9fa; }
  .tabela-tes tbody tr:nth-child(even) > td.col-acoes { background: #fbfcfd; }
  .tabela-tes tbody tr:hover > td.col-acoes, .tabela-tes tbody tr.sel > td.col-acoes { background: #eaf5ff; }
  .tabela-tes tfoot td.col-acoes { background: #f7f9fa; }
  .tabela-tes .sub.mono { font-family: 'IBM Plex Mono', Consolas, monospace; }
  .tabela-tes .sub-azul { color: #4f6b86; }
  .tabela-tes .sub.sub-op { color: #b06a15; font-weight: 600; }
  .tabela-tes .sub-ok { color: #0a6d4d; }
  .c-conta { font-weight: 600; color: #1a2035; }
  .ok { color: #0a6d4d; }
  .neg { color: #c0392b; font-weight: 600; }
  .mudo { color: #b3b9c0; }
  .div-cel { display: inline-flex; align-items: center; justify-content: flex-end; gap: 5px; }
  .div-vermelho { color: #c0392b; }
  .div-laranja { color: #d68a00; }
  .div-roxo { color: #5b3a9e; }
  .livre { font-weight: 700; color: #1c2024; font-size: 13px; }
  .livre.mudo { color: #b3b9c0; font-weight: 600; }
  .tabela-tes tbody tr > td.livre-ok { background: #eef9f4; }
  .tabela-tes tbody tr > td.livre-parado { background: #fdf6e7; }
  .livre-coberto { color: #9aa3ab; font-weight: 600; }

  .st { display: inline-flex; align-items: center; gap: 6px; padding: 4px 10px; border-radius: 12px; font-size: 11.5px; font-weight: 600; line-height: 1; white-space: nowrap; }
  .st:before { content: ""; width: 6px; height: 6px; border-radius: 50%; background: currentColor; }
  .st-ok { background: #f1f3f5; color: #6b747e; }
  .st-livre { background: #e5f7f0; color: #0a6d4d; }
  .st-parado { background: #fdf3e0; color: #8a5a00; }
  .st-diverg { background: #fdecec; color: #a13c3c; }
  .st-pendente { background: #fdf1e2; color: #b06a15; }
  .pend-val { color: #b06a15; font-weight: 600; }
  .st-semext { background: #eef3f8; color: #4f6b86; }
  .st-baixa { background: #f1ecfa; color: #5b3a9e; }

  .chip { display: inline-flex; align-items: center; font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: .3px; border-radius: 10px; padding: 1px 7px; line-height: 15px; white-space: nowrap; border: 1px solid transparent; margin-left: 4px; vertical-align: middle; }
  .chip-cinza { color: #5b6570; background: #f1f3f5; border-color: #dfe3e8; }
  .chip-vermelho { color: #a13c3c; background: #fdecec; border-color: #f5c6c6; }

  .lnk-valor { background: none; border: none; padding: 0; font: inherit; color: #1f5e9c; cursor: pointer; border-bottom: 1px dashed #9fb8d4; }
  .lnk-valor:hover { color: #12876f; border-bottom-color: #1ab394; }
  .lnk-valor.lnk-atrasado { color: #a13c3c; border-bottom-color: #e0a7a7; }
  .btn-ver { display: inline-flex; align-items: center; gap: 6px; height: 30px; padding: 0 12px; border-radius: 4px; border: 1px solid #1ab394; background: #fff; color: #12876f; font-size: 12.5px; font-weight: 600; cursor: pointer; white-space: nowrap; }
  .btn-ver:hover { background: #1ab394; color: #fff; }
  .acoes-linha { display: inline-flex; gap: 6px; }
  .btn-conciliar { display: inline-flex; align-items: center; gap: 6px; height: 30px; padding: 0 12px; border-radius: 4px; border: 1px solid #1c84c6; background: #fff; color: #1c6fa3; font-size: 12.5px; font-weight: 600; cursor: pointer; white-space: nowrap; }
  .btn-conciliar:hover { background: #1c84c6; color: #fff; }
  .btn-aplic { display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; margin-left: 6px; border-radius: 4px; border: 1px solid #dfe3e8; background: #fff; color: #8a939c; font-size: 12.5px; cursor: pointer; }
  .btn-aplic:hover { border-color: #1ab394; color: #12876f; background: #f2fbf8; }

  .vazio-lista { text-align: center; padding: 30px 10px !important; color: #8a939c; }
  .vazio-lista .fa { font-size: 30px; color: #c7cdd4; }
  .vz-t { font-size: 13.5px; font-weight: 600; color: #5b6570; margin-top: 6px; }
  .vz-s { font-size: 12px; }
  .skel { background: #eef1f4; border-radius: 4px; height: 12px; }

  .rodape { flex: 0 0 auto; display: grid; grid-template-columns: 1fr auto 1fr; align-items: center; padding: 10px 16px; border-top: 1px solid #dfe3e8; background: #f7f9fa; }
  .rodape-l { display: flex; align-items: center; gap: 8px; }
  .rodape-c { display: flex; flex-direction: column; align-items: center; gap: 4px; }
  .rodape-r { display: flex; justify-content: flex-end; align-items: center; gap: 8px; }
  .pag { display: inline-flex; align-items: center; gap: 2px; }
  .pag button { min-width: 30px; height: 30px; padding: 0 9px; border: 1px solid #dfe3e8; background: #fff; color: #5b6570; font-size: 12.5px; cursor: pointer; }
  .pag button.ativo { background: #1ab394; border-color: #1ab394; color: #fff; font-weight: 600; }
  .pag button[disabled] { color: #c7cdd4; cursor: default; }
  .pag-info { font-size: 11.5px; color: #8a939c; }
  .btn-sair { background: #fdf1f1; border: 1px solid #e4d7d7; color: #a13c3c; font-weight: 600; }
  .btn-sair:hover { background: #fbe7e7; border-color: #d9c2c2; color: #a13c3c; }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/conciliacao-projeto/componentes/PosicaoTesourariaLista.vue